import { render } from "./Construction.vue?vue&type=template&id=3760beaf"
import script from "./Construction.vue?vue&type=script&lang=js"
export * from "./Construction.vue?vue&type=script&lang=js"
script.render = render

export default script